/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import injectSheet from 'react-jss';
import DownArrow from 'Assets/ui/dropdownarrow.svg';
import { useSelect } from 'downshift';
import styleSheet from './styles';

interface Props {
  top?: string;
  width?: string;
  classes?: any;
  items: any;
  defaultValue?: any;
  onChange?: (e: object) => void;
  onUserAction?: (e: object) => void;
  colorOverRide?: any;
  fontOverride?: string;
  ariaLabel?: string;
}

const Dropdown = (props: Props) => {
  const {
    classes,
    defaultValue: selectedItem,
    items,
    onChange,
    onUserAction,
    colorOverRide,
    ariaLabel,
  } = props;

  const handleChange = (changes) => {
    const response = {
      target: changes?.selectedItem,
    };
    if (onChange) {
      onChange(response);
    }
  };

  const handleUserAction = (event: any) => {
    if (onUserAction) {
      onUserAction(event);
    }
  };

  const {
    isOpen,
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    highlightedIndex,
    getItemProps,
  } = useSelect({
    items,
    itemToString: (item) => (item ? item.label : ''),
    selectedItem,
    onSelectedItemChange: handleChange,
    onIsOpenChange: handleUserAction,
  });

  return (
    <div className={classes.wrapper}>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label {...getLabelProps()} style={{ display: 'none' }}>
        {ariaLabel}
      </label>
      <button
        type="button"
        data-type="list"
        className={classes.select}
        style={{
          border: isOpen
            ? `1.5px solid ${colorOverRide?.open?.border?.color || '#085FE5'}`
            : `1.5px solid ${colorOverRide?.close?.border?.color || '#B4CFF7'}`,
        }}
        {...getToggleButtonProps()}
      >
        {selectedItem?.label || 'Select'}
        <div
          className={classes.dropdownArrow}
          style={{
            transform: isOpen
              ? 'scale(0.8) rotate(180deg)'
              : 'scale(0.8) rotate(0deg)',
          }}
        >
          <DownArrow />
        </div>
      </button>
      <ul
        className={`${classes.optionsHolder} ${isOpen ? classes.dropDown : ''}`}
        {...getMenuProps()}
      >
        {isOpen &&
          items.map((item: any, index: number) => (
            <li
              key={item.value}
              className={classes.dropDownItem}
              {...getItemProps({ index, item })}
              style={{
                backgroundColor:
                  highlightedIndex === index
                    ? 'rgba(8, 95, 229, 0.1)'
                    : 'transparent',
              }}
            >
              {item.label}
            </li>
          ))}
      </ul>
    </div>
  );
};

Dropdown.defaultProps = {
  top: '0',
  width: '',
  classes: {},
  defaultValue: null,
  onChange: () => {},
  onUserAction: () => {},
  colorOverRide: {},
  fontOverride: '',
  ariaLabel: '',
};

export default injectSheet(styleSheet)(Dropdown);
